import { mapActions } from 'vuex';

const manageMainItemMixin = {
  data: () => ({
    items: [],
    selectedItems: [],
    totalItems: 0,
    clonedItem: {},
    manageMainItem: {
      isMultiple: true,
      itemController: '',
      itemName: '',
      itemIdentifyField: 'id',
    },
  }),

  methods: {
    ...mapActions({
      setSnack: 'snackbar/setState',
    }),

    getCreateNewItemDataHook() {
      return {};
    },

    // eslint-disable-next-line no-unused-vars
    addItemHook(item) {

    },

    // eslint-disable-next-line no-unused-vars
    updateItemHook(result) {

    },

    closeSaveNewHook() {
      this.closeDialog('createNewDialog');
    },

    addItem(item) {
      this.items.unshift(item);
      this.totalItems += 1;
      this.addItemHook(item);
    },

    saveNew() {
      const { data } = this.getCreateNewItemDataHook();

      this.$requestHelpers.post(
        `api/admin/${this.manageMainItem.itemController}`,
        data,
      )
        .then((response) => {
          if (this.manageMainItem.isMultiple) {
            this.addItem(response.data.result);
          }
        })
        .finally(() => {
          this.closeSaveNewHook();
        });

      return true;
    },

    cloneItem(item) {
      this.clonedItem = Object.assign(this.clonedItem, item);
    },

    updateItem(itemClone, item, successCallback = null, failCallback = null) {
      return this.$requestHelpers
        .patch(`api/admin/${this.manageMainItem.itemController}/${itemClone.id}`, itemClone)
        .then((response) => {
          Object.assign(item, response.data.result);

          if (typeof successCallback === 'function') {
            successCallback(response.data.result);
          } else {
            this.updateItemHook(response.data.result);
          }
        }).catch((err) => {
          if (typeof failCallback === 'function') {
            failCallback(err);
          } else if (err.status === 200) {
            Object.assign(item, err.data.result);
          }
        });
    },

    updateBulk(itemIds, itemFields) {
      return this.$requestHelpers
        .post(`api/admin/${this.manageMainItem.itemController}/updateBulk`, { itemIds, itemFields })
        .then((response) => {
          if (response.data.success) {
            let commonStatus = true;
            for (let i = 0; i < response.data.result.statuses.length; i += 1) {
              const { status } = response.data.result.statuses[i];

              commonStatus &&= status;

              if (status) {
                const item = response.data.result.items[i];
                const index = this.items.findIndex((e) => e.id === item.id);

                Object.assign(this.items[index], item);
              }
            }

            if (commonStatus) {
              this.setSnack({
                color: 'green',
                text: response.data.message ? response.data.message : 'saved',
              });
            } else {
              this.setSnack({
                color: 'orange',
                text: response.data.message,
              });
            }
          }
        }).finally(() => {
          this.selectedItems = [];
        });
    },

    removeItem(item) {
      this.items = this.items.filter((e) => e.id !== item.id);
      this.totalItems -= 1;
    },

    remove(item) {
      this.$confirm(
        `Are you sure you want to delete ${this.manageMainItem.itemName} ${item[this.manageMainItem.itemIdentifyField]}?`,
      ).then((res) => {
        if (!res) return;

        this.$requestHelpers
          .delete(`api/admin/${this.manageMainItem.itemController}/${item.id}`)
          .then(() => {
            this.removeItem(item);
          });
      });
    },

    clearSelectedItems() {
      this.selectedItems = [];
    },
  },
};

export default manageMainItemMixin;
